import { Component, OnInit, Input } from '@angular/core';
// import { Offer } from '@app/shared';
import { Offer } from '../../models/offer';

import { Store } from '@ngrx/store';
import { AppState, selectOfferState } from '@app/store/app.states';
import { map } from 'rxjs/operators';

import { UpdateFaveOffers,GetFaveOffers } from '@app/store/actions/offer.actions';

import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';


export enum FaveActionTypes {
  REMOVE = 'remove',
  ADD = 'add',
}

@Component({
  selector: 'app-offer-fave',
  templateUrl: './offer-fave.component.html',
  styleUrls: ['./offer-fave.component.scss']
})
export class OfferFaveComponent implements OnInit {

  @Input()
  offer:Offer;

  // @Input()
  //isSelected:boolean = false;

  private getOfferState$: Observable<any>;
  private offerStoreSubscription:Subscription;
  private offers:Offer[];

  constructor(private store:Store<AppState>,) { }

  ngOnInit() {

    this.getOfferState$ = this.store.select(selectOfferState);
    this.offerStoreSubscription = this.getOfferState$.subscribe((state) => {
      this.offers = state.favourites;
    });

  }

  toggleFave():void{
    //this.selected = !this.selected;

    let action = this.isSelected()?FaveActionTypes.REMOVE:FaveActionTypes.ADD;
    const payload = {offer:this.offer, action:action };
    this.store.dispatch(new UpdateFaveOffers(payload));
  }

  // destroy subscriptions
  ngOnDestroy():void{
      this.offerStoreSubscription.unsubscribe();
  }

  public isSelected():boolean{
    let result = false;
    if(this.offers){
      let tmpOffer = this.offers.find(offer => offer.uuid === this.offer.uuid);
      if(tmpOffer)result = true;
    }
    return result;
  }


}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/components/offer-fave/offer-fave.component.ts